const categories = [
  { id: "meat", name: "Meat" },
  { id: "books", name: "Books" },
  { id: "clothing", name: "Clothing" },
  { id: "cream", name: "Cream" },
  { id: "services", name: "Services" },
];

export default categories;
